import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newFields", "selectFields", "input", "select"]
  static values = { initial: String }

  connect() {
    this.renderState(this.initialValue)
  }

  update(event) {
    const state = event.target.value
    this.renderState(state)
  }

  renderState(state) {
    this.newFieldsTarget.classList.toggle("d-none", state !== "new")
    this.selectFieldsTarget.classList.toggle("d-none", state !== "existing")
  }
}